import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon } from 'lucide-react';
interface LegalModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}
export function LegalModal({
  isOpen,
  onClose,
  title,
  children
}: LegalModalProps) {
  return <AnimatePresence data-id="element-307">
      {isOpen && <>
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.3
      }} className="fixed inset-0 bg-black/70 backdrop-blur-sm z-50" onClick={onClose} data-id="element-308" />

          <motion.div initial={{
        opacity: 0,
        y: 40,
        scale: 0.97
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 20,
        scale: 0.97
      }} transition={{
        duration: 0.35,
        ease: [0.21, 0.47, 0.32, 0.98]
      }} className="fixed inset-4 md:inset-auto md:top-1/2 md:left-1/2 md:-translate-x-1/2 md:-translate-y-1/2 md:w-full md:max-w-2xl md:max-h-[80vh] bg-navy rounded-2xl shadow-2xl z-50 flex flex-col overflow-hidden" data-id="element-309">
            <div className="flex items-center justify-between px-6 py-5 border-b border-gold/10 flex-shrink-0" data-id="element-310">
              <h2 className="text-xl md:text-2xl font-serif font-bold text-gold" data-id="element-311">
                {title}
              </h2>
              <button onClick={onClose} className="p-2 rounded-full hover:bg-white/5 transition-colors" aria-label="Cerrar" data-id="element-312">
                <XIcon className="w-5 h-5 text-white/50" data-id="element-313" />
              </button>
            </div>

            <div className="overflow-y-auto px-6 py-6 flex-1" data-id="element-314">
              <div className="max-w-none text-white/70 leading-relaxed space-y-4 text-sm md:text-base [&_h3]:text-gold [&_h3]:font-serif [&_h3]:font-bold [&_h3]:text-lg [&_h3]:mt-6 [&_strong]:text-white" data-id="element-315">
                {children}
              </div>
            </div>

            <div className="px-6 py-4 border-t border-gold/10 flex-shrink-0 text-center" data-id="element-316">
              <button onClick={onClose} className="text-sm font-medium text-gold hover:text-gold-dark transition-colors" data-id="element-317">
                Cerrar
              </button>
            </div>
          </motion.div>
        </>}
    </AnimatePresence>;
}